var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 6,
    fill: "#0A66C2"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_245_1519)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5 6.86765C5 6.41719 5.15766 6.04557 5.47297 5.75279C5.78828 5.45999 6.1982 5.3136 6.7027 5.3136C7.1982 5.3136 7.59909 5.45773 7.90541 5.74603C8.22072 6.04333 8.37838 6.43071 8.37838 6.90819C8.37838 7.34063 8.22523 7.70098 7.91892 7.98927C7.60361 8.28657 7.18919 8.43522 6.67568 8.43522H6.66216C6.16666 8.43522 5.76577 8.28657 5.45946 7.98927C5.15315 7.69198 5 7.3181 5 6.86765ZM5.17568 18.692V9.66495H8.17568V18.692H5.17568ZM9.83784 18.692H12.8378V13.6514C12.8378 13.3361 12.8739 13.0929 12.9459 12.9217C13.0721 12.6154 13.2635 12.3564 13.5203 12.1447C13.777 11.933 14.0991 11.8271 14.4865 11.8271C15.4955 11.8271 16 12.5073 16 13.8677V18.692H19V13.5163C19 12.183 18.6847 11.1717 18.0541 10.4825C17.4234 9.79333 16.5901 9.44873 15.5541 9.44873C14.3919 9.44873 13.4865 9.94873 12.8378 10.9487V10.9758H12.8243L12.8378 10.9487V9.66495H9.83784C9.85585 9.95323 9.86486 10.8496 9.86486 12.3541C9.86486 13.8586 9.85585 15.9712 9.83784 18.692Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_245_1519"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white",
    transform: "translate(5 5)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/_Linkedin.8252e107f66929a4cf144b9b60f791b5.svg";
export { ForwardRef as ReactComponent };